<template>
	<div>
		<!-- <el-dialog
			:center="true"
			:visible.sync="show"
			:close-on-click-modal="false"
			width="700px"
			class="countdownDialog"
		>
			<div class="a-d-top">
				<div class="a-d-topTit">
					<div>{{ lang.set_the_countdown }}</div>
				</div>
				<div class="a-d-t-right">
					<span @click="close()">×</span>
				</div>
			</div>
			<div class="cd_box" v-loading="loading">
				<el-form
					label-position="top"
					label-width="80px"
					style="width: 100%;"
					:model="form"
				>
					<el-form-item :label="lang.countdown_time">
						<el-input v-model="form.time"></el-input>
					</el-form-item>
					<el-form-item :label="lang.end_prompt_message">
						<el-input v-model="form.message"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="cd_bottom">
				<el-button @click="close()">{{ lang.cancel }}</el-button>
				<el-button type="primary" @click="submit()">{{
					lang.queding
				}}</el-button>
			</div>
		</el-dialog> -->
		<el-dialog
			:center="true"
			:visible.sync="show"
			:close-on-click-modal="false"
			:modal="true"
			width="auto"
			height="auto"
			:append-to-body="true"
			class="dialog"
		>
			<div class="box">
				<div class="b_head">
					<span>{{ lang.send_a_message }}</span>
					<svg
						@click="close()"
						t="1748587270371"
						class="icon"
						viewBox="0 0 1024 1024"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						p-id="5023"
						width="200"
						height="200"
					>
						<path
							d="M0 0h1024v1024H0z"
							fill="#FF0033"
							fill-opacity="0"
							p-id="5024"
						></path>
						<path
							d="M240.448 168l2.346667 2.154667 289.92 289.941333 279.253333-279.253333a42.666667 42.666667 0 0 1 62.506667 58.026666l-2.133334 2.346667-279.296 279.210667 279.274667 279.253333a42.666667 42.666667 0 0 1-58.005333 62.528l-2.346667-2.176-279.253333-279.253333-289.92 289.962666a42.666667 42.666667 0 0 1-62.506667-58.005333l2.154667-2.346667 289.941333-289.962666-289.92-289.92a42.666667 42.666667 0 0 1 57.984-62.506667z"
							fill="#111111"
							p-id="5025"
						></path>
					</svg>
				</div>
				<div class="b_main" v-loading="loading">
					<el-form
					label-position="top"
					label-width="80px"
					style="width: 100%;"
					:model="form"
				>
					<el-form-item :label="lang.countdown_time">
						<el-input v-model.number="form.time"></el-input>
					</el-form-item>
					<el-form-item :label="lang.end_prompt_message">
						<el-autocomplete style="width: 100%;" v-model="form.message" :fetch-suggestions="querySearch"></el-autocomplete>
					</el-form-item>
				</el-form>
				</div>
				<div class="b_bottom">
					<el-button size="small" @click="close()">{{
						lang.cancel
					}}</el-button>
					<el-button size="small" type="primary" @click="submit()">{{
						lang.queding
					}}</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loading: false,
			show: false,
			data: null,
			form: {
				time: "",
				message: "",
			},
			messageList:[{value:this.lang.timeUpMessage}]
		};
	},
	computed: {},
	methods: {
		open(data) {
			this.data = data;
			this.loading = false;
			this.show = true;
		},
		close() {
			this.show = false;
			this.init();
		},
		init() {
			this.data = null;
			this.loading = false;
			this.form = {
				time:"",
				message:"",
			}
		},
		submit() {
			if(!this.form.time)return this.$message.error(this.lang.pleaseEnterCountdownTime);

			this.$emit("success",{msg:this.form.message,time:this.form.time});
			// this.$message.info(
			// 	`设置倒计时：${this.form.time}分钟,结束提示消息：${this.form.message}`
			// );
		},
		querySearch(queryString,cb){
			return cb(this.messageList)
		},
	},
};
</script>

<style scoped>
.dialog >>> .el-dialog {
	width: 700px !important;
	border-radius: 8px;
	padding: 0;
	background-color: #fff;
	overflow: hidden;
}

.dialog >>> .el-dialog__body {
	width: 700px !important;
	height: auto;
	flex-shrink: 0;
	padding: 0;
	box-sizing: border-box;
	overflow: auto;
}

.dialog >>> .el-dialog__header {
	display: none !important;
}

.box {
	width: 700px;
	height: auto;
	background: #fafafa;
	border-radius: 15px;
	box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05),
		0px 16px 24px 2px rgba(0, 0, 0, 0.04), 0px 8px 10px -5px rgba(0, 0, 0, 0.08);
}

.b_head {
	width: 100%;
	height: 50px;
	border-radius: 15px 15px 0 0;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-sizing: border-box;
	padding: 0 20px;
}

.b_head > span {
	font-size: 18px;
	font-weight: bold;
	color: #000;
}

.b_head > img {
	width: 20px;
	height: 20px;
	cursor: pointer;
}

.b_head > svg {
	width: 20px;
	height: 20px;
	cursor: pointer;
}

.b_main {
	width: 100%;
	height: auto;
	background: #fafafa;
	padding: 20px 20px 20px 20px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.b_bottom {
	width: 100%;
	height: 70px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	box-sizing: border-box;
	padding: 0 20px;
}
</style>
